// extracted by mini-css-extract-plugin
module.exports = {"container":"FlavorFinderViewSwitch_container__ASTo3"};